import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'ff-accordion-cell',
  templateUrl: './accordion-cell.component.html',
  styleUrls: ['./accordion-cell.component.scss']
})
export class AccordionCellComponent implements OnInit {

  @ViewChild('template') template: TemplateRef<any>;

  /**
   * Boolean to set whether the text should wrap or not
   * Default value: true
   */ 
  @Input() textWrap: boolean = false;

  /**
   * Tooltip text to be displayed
   */
  @Input() tooltipText?: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
